import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSubtract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={10}
    fill="none"
    {...props}
  >
    <path
      fill="#38B762"
      d="M5.428.115c.204-.136.475-.17.679 0a.52.52 0 0 1 .17.646l-1.631 3.6h2.446c.204 0 .408.17.51.374.068.204 0 .442-.17.612L2.201 9.695a.57.57 0 0 1-.34.103.44.44 0 0 1-.34-.137.52.52 0 0 1-.17-.645l1.63-3.568H.537c-.204 0-.408-.169-.51-.373-.068-.203 0-.441.17-.611z"
    />
  </svg>
);
export default SvgSubtract;
